import { render, staticRenderFns } from "./devicePage.vue?vue&type=template&id=538a62ac&scoped=true"
import script from "./devicePage.vue?vue&type=script&lang=js"
export * from "./devicePage.vue?vue&type=script&lang=js"
import style0 from "./devicePage.vue?vue&type=style&index=0&id=538a62ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538a62ac",
  null
  
)

export default component.exports